
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"#fff","viewBox":"0 0 32 32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14 22.733l5.307-3.04c.893-.507.893-1.8 0-2.32L14 14.333c-.893-.507-2 .147-2 1.16v6.067c0 1.026 1.107 1.68 2 1.173zM28 7.866H17.88l3.92-3.92a.66.66 0 000-.947.66.66 0 00-.947 0L16 7.853l-4.853-4.854a.66.66 0 00-.947 0 .66.66 0 000 .947l3.92 3.92H4a2.666 2.666 0 00-2.667 2.667v16c0 1.466 1.2 2.666 2.667 2.666h24c1.467 0 2.667-1.2 2.667-2.666v-16c0-1.48-1.2-2.667-2.667-2.667zm-1.333 18.667H5.334C4.6 26.533 4 25.933 4 25.2V11.867c0-.734.6-1.334 1.334-1.334h21.333c.733 0 1.333.6 1.333 1.334V25.2c0 .733-.6 1.333-1.333 1.333z"}})])
          )
        }
      }
    